<template>
    <div>
        <v-row>
            <v-col>
                <p v-if="activeUsers > enterpriseTotalSeats">
                    <v-alert
                        class="mb-0"
                        color="error"
                        type="warning"
                        dismissible>
                        <h4>The Active User count for your Enterprise profile has exceeded the number of available seats.  Please contact your ICC Specialist to add additional seats or deactivate users from the Manage Users tab.</h4>
                    </v-alert>
                </p>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="auto" class="flex-grow-1">
                <v-card height="100%" class="rounded-xl primary">
                    <v-card-subtitle class="white--text pb-0 pt-0">
                        <v-row>
                            <v-col cols="auto">
                                Total Enterprise Seats
                                <v-tooltip
                                    top
                                    color="black">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            color="white"
                                            v-bind="attrs"
                                            v-on="on"
                                            small>
                                            info
                                        </v-icon>
                                    </template>
                                    <span class="tooltip-content">
                                        <p class="caption mb-0">
                                            The total number of purchased Enterprise seats.<br/>
                                            When Active Users exceeds Total Enterprise Seats,<br/>
                                            admin can either add seats or deactivate<br/>
                                            users to be within Total Seats quantity.
                                        </p>
                                    </span>
                                </v-tooltip>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col class="text-right">
                                {{ enterpriseTotalSeats }}
                            </v-col>
                        </v-row>
                    </v-card-subtitle>
                </v-card>
            </v-col>
            <v-col cols="12" md="auto" class="flex-grow-1">
                <v-card height="100%" class="primary rounded-xl">
                    <v-card-subtitle class="white--text pb-0 pt-0">
                        <v-row>
                            <v-col cols="auto">
                                Total Users
                                <v-tooltip
                                    top
                                    color="black">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            color="white"
                                            v-bind="attrs"
                                            v-on="on"
                                            small>
                                            info
                                        </v-icon>
                                    </template>
                                    <span class="tooltip-content">
                                        <p class="caption mb-0">
                                            Any individual invited to the Enterprise profile<br/>
                                            and listed in the Manage Users table.
                                        </p>
                                    </span>
                                </v-tooltip>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col class="text-right">
                                {{ totalUsers }}
                            </v-col>
                        </v-row>
                    </v-card-subtitle>
                </v-card>
            </v-col>
            <v-col cols="12" md="auto" class="flex-grow-1">
                <v-card height="100%" class="primary rounded-xl">
                    <v-card-subtitle class="white--text pb-0 pt-0">
                        <v-row>
                            <v-col cols="auto">
                                Active Users
                                <v-tooltip
                                    top
                                    color="black">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            color="white"
                                            v-bind="attrs"
                                            v-on="on"
                                            small>
                                            info
                                        </v-icon>
                                    </template>
                                    <span class="tooltip-content">
                                        <p class="caption mb-0">
                                            Individuals who have accepted their invitation<br/>
                                            and are currently able to access Premium contents and features.
                                        </p>
                                    </span>
                                </v-tooltip>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col class="text-right">
                                {{ activeUsers }}
                            </v-col>
                        </v-row>
                    </v-card-subtitle>
                </v-card>
            </v-col>
            <v-col cols="12" md="auto" class="flex-grow-1">
                <v-card height="100%" class="primary rounded-xl">
                    <v-card-subtitle class="white--text pb-0 pt-0">
                        <v-row>
                            <v-col cols="auto">
                                Pending Users
                                <v-tooltip
                                    top
                                    color="black">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            color="white"
                                            v-bind="attrs"
                                            v-on="on"
                                            small>
                                            info
                                        </v-icon>
                                    </template>
                                    <span class="tooltip-content">
                                        <p class="caption mb-0">
                                            Individuals who have been invited to the Enterprise<br/>
                                            but have not yet accepted the invite.<br/>
                                            Once the invite is accepted,<br/>
                                            user transitions automatically from Pending User to Active User.
                                        </p>
                                    </span>
                                </v-tooltip>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col class="text-right">
                                {{ pendingUsers }}
                            </v-col>
                        </v-row>
                    </v-card-subtitle>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
export default {
    props: [
        'activeUsers',
        'pendingUsers',
        'enterpriseTotalSeats',
        'totalUsers'
    ],
}
</script>
